import { type PricingRuleValues, ruleValue } from './pricing-rules.ts'

/**
 * THE TEN-REEL PACKAGE — ten reels of one level at one price.
 *
 * Owner, 2026-10-15: „dodajemy pakiety 10 sztuk z opcją przełącznika na
 * stronie". A package is not a new thing to buy: it is exactly ten of the
 * ordinary reel, so everything the system already does per reel keeps working
 * — ten jobs, ten editor payouts at the usual rate, ten times the footage
 * allowance. The only thing that changes is what the ten cost together.
 *
 * Shared by the page, the browser's estimate and the checkout, because the
 * three of them disagreeing by a grosz is a basket that will not pay.
 */
export const REEL_PACK_SIZE = 10

/** The reel offering, and the rule holding each level's package price. */
const REEL_OFFERING_SLUG = 'rolka'

const PACK_RULE_BY_VARIANT: Readonly<Record<string, string>> = {
  starter: 'reels.pack10.clean_net_minor',
  creator: 'reels.pack10.dynamic_net_minor',
  pro: 'reels.pack10.advanced_net_minor',
}

/** What ten reels of this level cost together, or `null` where no package exists. */
export function reelPackNetMinor(
  offeringSlug: string,
  variantSlug: string | null | undefined,
  rules: PricingRuleValues,
): number | null {
  if (offeringSlug !== REEL_OFFERING_SLUG || !variantSlug) return null
  const key = PACK_RULE_BY_VARIANT[variantSlug]
  return key ? ruleValue(rules, key) : null
}

/**
 * The unit price a line is charged at: the package's tenth when exactly ten
 * reels of one level are bought, the catalogue price otherwise.
 *
 * Exactly ten, not „ten or more": the switch on the page sells ten, and eleven
 * reels at a package rate would be a discount nobody set. A tenth is exact for
 * any whole-złoty package (889 zł → 88,90 zł), so ten rows of it add back up to
 * the package to the grosz.
 */
export function reelUnitNetMinor(
  offeringSlug: string,
  variantSlug: string | null | undefined,
  quantity: number,
  listUnitNetMinor: number | null,
  rules: PricingRuleValues,
): number | null {
  if (listUnitNetMinor === null || quantity !== REEL_PACK_SIZE) return listUnitNetMinor
  const pack = reelPackNetMinor(offeringSlug, variantSlug, rules)
  return pack === null ? listUnitNetMinor : Math.round(pack / REEL_PACK_SIZE)
}
